// Example: http://localhost:8080
export const soundsLocation = 'https://cdn.heyzeer0.net/sounds';
